"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaContext = void 0;
var SchemaContext;
(function (SchemaContext) {
    /** Schema is used as an input to an operation. */
    SchemaContext["Input"] = "input";
    /** Schema is used as an output from an operation. */
    SchemaContext["Output"] = "output";
    /** Schema is used as an exception from an operation. */
    SchemaContext["Exception"] = "exception";
})(SchemaContext || (exports.SchemaContext = SchemaContext = {}));
//# sourceMappingURL=usage.js.map